import { gql } from '@apollo/client'

export const GET_DISPLAY_LOCATIONS = gql`
  query DisplayLocations($input: DisplayLocationsInput!) {
    displayLocations(input: $input) {
      count
      results {
        name
        id
        types {
          category
        }
      }
    }
  }
`
